/// Player feedback submission. Wraps the `submitFeedbackPost`
/// Cloud Function which publishes the feedback as an anonymous
/// post on the Talk-to-the-developer board (public visibility, no
/// identifier) plus a private `webFeedbackOwners` mapping (dev-
/// readable only) so future replies can be routed back to the
/// submitter.

import { httpsCallable } from 'firebase/functions'
import { firebaseFunctions } from '../firebase/app'

interface SubmitArgs {
  rating: number
  text: string
  levelId?: string | null
}

interface SubmitResult {
  ok: boolean
  postId?: string
}

export async function submitFeedback(args: SubmitArgs): Promise<{ postId: string | null }> {
  const fn = httpsCallable<SubmitArgs & { userAgent: string }, SubmitResult>(
    firebaseFunctions,
    'submitFeedbackPost',
  )
  const res = await fn({
    rating: args.rating,
    text: args.text,
    levelId: args.levelId ?? null,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
  })
  return { postId: res.data?.postId ?? null }
}
